var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'd-flex flex-row justify-space-between': _vm.row }},[_c('span',{staticClass:"subtitle-2 font-weight-bold mb-2 underline"},[_vm._v(_vm._s(this.title))]),_vm._l((_vm.texts),function(text,index){return _c('p',{key:index,staticClass:"body-1 font-weight-bold mb-0"},[_vm._v(" "+_vm._s(text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }